import Cookies from "js-cookie";

/** Comma-separated roles from login cookie (same shape as Navbar). */
export const parseUserRoles = () =>
    (Cookies.get("userRole") || "").split(",").map((r) => r.trim()).filter(Boolean);

/**
 * User has CRM app access (sidebar). Matches API expectation that CRM writes require
 * CRM-ADMIN or CRM-USER in user_role (backend applies created_by / peer rules).
 */
export const hasCrmRole = () => {
    const r = parseUserRoles();
    return r.includes("CRM-ADMIN") || r.includes("CRM-USER");
};

export const isCrmAdmin = () => parseUserRoles().includes("CRM-ADMIN");
